import { useState } from 'react'
import { 
  DocumentTextIcon,
  ChartBarIcon,
  CpuChipIcon,
  WrenchScrewdriverIcon,
  ClockIcon,
  CurrencyDollarIcon,
  ShieldCheckIcon,
  RocketLaunchIcon,
  BuildingOfficeIcon,
  CalculatorIcon,
  AcademicCapIcon,
  ChartPieIcon,
  DeviceTabletIcon,
  CheckCircleIcon,
  ArrowRightIcon,
  CalendarIcon,
  BanknotesIcon,
  UserGroupIcon,
  ShieldExclamationIcon,
  BeakerIcon,
  ClipboardDocumentCheckIcon,
  MagnifyingGlassIcon,
  CalendarDaysIcon,
  ChartBarSquareIcon,
  CubeIcon,
  LanguageIcon,
  BriefcaseIcon,
  DocumentDuplicateIcon,
  GlobeAltIcon,
  ServerIcon,
  CloudArrowUpIcon,
  SparklesIcon,
  PresentationChartLineIcon,
  TruckIcon,
  ShoppingBagIcon,
  UsersIcon,
  CreditCardIcon,
  MapPinIcon,
  TagIcon,
  PhoneIcon,
  EnvelopeIcon
} from '@heroicons/react/24/outline'

import logo from './img/ziaran-logo.png';

function Proposal() {
  const [activePhase, setActivePhase] = useState(1)
  const [activeSection, setActiveSection] = useState('executive')

  // رنگ‌های برند شرکت گوشت مهر گستران (سبز + طلایی)
  const primaryColor = 'rgb(0, 102, 51)' // سبز تیره
  const primaryColorLight = 'rgba(0, 102, 51, 0.12)'
  const primaryColorSuperLight = 'rgba(0, 102, 51, 0.05)'
  const primaryColorDark = 'rgb(0, 77, 38)'
  const goldColor = 'rgb(184, 134, 11)'
  const goldColorLight = 'rgba(184, 134, 11, 0.15)'

  // ================ خدمات اصلی پلتفرم ================
  const mainServices = [
    {
      name: "ثبت و فروش دام",
      description: "فروشندگان می‌توانند دام‌های خود را با مشخصات کامل ثبت کنند",
      features: ["ثبت مشخصات دام (نوع، وزن، سن، نژاد)", "بارگذاری تصاویر و ویدئو", "تعیین قیمت و محل"],
      icon: <CubeIcon className="w-8 h-8" />,
      formType: "ثبت دام"
    },
    {
      name: "خرید دام",
      description: "خریداران می‌توانند دام‌های مورد نظر را جستجو و خریداری کنند",
      features: ["جستجوی پیشرفته با فیلترهای متعدد", "مشاهده جزئیات کامل دام", "ثبت سفارش آنلاین"],
      icon: <ShoppingBagIcon className="w-8 h-8" />,
      formType: "سفارش خرید"
    },
    {
      name: "فرآورده‌های دامی",
      description: "فروش انواع فرآورده‌های دامی مانند گوشت، شیر، پشم و ...",
      features: ["ثبت فرآورده‌های دامی", "تعیین وزن و بسته‌بندی", "قیمت‌گذاری محصولات"],
      icon: <TagIcon className="w-8 h-8" />,
      formType: "ثبت محصول"
    },
    {
      name: "پرداخت آنلاین",
      description: "پرداخت امن و سریع از طریق درگاه‌های معتبر بانکی",
      features: ["اتصال به درگاه‌های پرداخت معتبر", "پرداخت امن با رمز دوم", "تسویه حساب خودکار فروشندگان"],
      icon: <CreditCardIcon className="w-8 h-8" />,
      formType: "پرداخت"
    },
    {
      name: "حمل و نقل تخصصی",
      description: "ارسال دام و فرآورده‌ها با خودروهای مخصوص حمل دام",
      features: ["ثبت درخواست حمل", "تخصیص خودروی مخصوص", "رهگیری لحظه‌ای مسیر"],
      icon: <TruckIcon className="w-8 h-8" />,
      formType: "درخواست حمل"
    },
    {
      name: "بازار دام",
      description: "مشاهده قیمت‌های روز و تحلیل بازار دام و فرآورده‌ها",
      features: ["نمودار قیمت روز دام", "تحلیل روند بازار", "مقایسه قیمت فروشندگان"],
      icon: <ChartBarIcon className="w-8 h-8" />,
      formType: "داشبورد بازار"
    },
    {
      name: "امتیاز و نظرات",
      description: "سیستم شفافیت و اعتماد با امتیازدهی به فروشندگان",
      features: ["امتیازدهی به فروشندگان", "ثبت نظر و تجربه خرید", "مشاهده تاریخچه فروشنده"],
      icon: <ClipboardDocumentCheckIcon className="w-8 h-8" />,
      formType: "نظرات"
    },
    {
      name: "پیگیری سفارش",
      description: "مشاهده وضعیت سفارشات و حمل و نقل در یک داشبورد",
      features: ["وضعیت سفارش", "مسیر حمل و نقل", "تاریخچه خرید"],
      icon: <DocumentDuplicateIcon className="w-8 h-8" />,
      formType: "داشبورد پیگیری"
    }
  ]

  // ================ ویژگی‌های کلیدی ================
  const keyBenefits = [
    {
      title: "بازارگاه تخصصی دام",
      description: "پلتفرمی اختصاصی برای خرید و فروش انواع دام و فرآورده‌های دامی",
      icon: <BuildingOfficeIcon className="w-8 h-8" />
    },
    {
      title: "پرداخت امن و آنلاین",
      description: "اتصال به درگاه‌های پرداخت معتبر با امکان تسویه خودکار",
      icon: <ShieldCheckIcon className="w-8 h-8" />
    },
    {
      title: "حمل و نقل تخصصی",
      description: "سیستم حمل و نقل با خودروهای مخصوص مجهز به سردخانه و استانداردهای دام",
      icon: <TruckIcon className="w-8 h-8" />
    },
    {
      title: "دو نقش مجزا",
      description: "رابط کاربری اختصاصی برای فروشندگان و خریداران با امکانات متناسب",
      icon: <UsersIcon className="w-8 h-8" />
    },
    {
      title: "اعتماد و شفافیت",
      description: "سیستم امتیازدهی، نظرات و تأیید هویت فروشندگان",
      icon: <ShieldExclamationIcon className="w-8 h-8" />
    },
    {
      title: "تحلیل بازار لحظه‌ای",
      description: "داشبورد هوشمند با نمایش قیمت‌های روز و تحلیل روند بازار",
      icon: <PresentationChartLineIcon className="w-8 h-8" />
    }
  ]

  // ================ فاز اول ================
  const phase1Details = {
    title: "شروع پلتفرم خرید و فروش دام",
    duration: "۳-۴ ماه",
    icon: <GlobeAltIcon className="w-6 h-6" />,
    
    modules: [
      {
        category: "۱. وبسایت اصلی و پنل کاربری",
        items: [
          { name: "طراحی UI/UX مدرن و ریسپانسیو", status: "فعال" },
          { name: "سیستم ثبت‌نام و احراز هویت (خریدار/فروشنده)", status: "فعال" },
          { name: "پنل مدیریت یکپارچه", status: "فعال" },
          { name: "صفحات معرفی شرکت و خدمات", status: "فعال" }
        ]
      },
      {
        category: "۲. پنل فروشندگان (Seller Panel)",
        items: [
          { name: "ثبت و مدیریت دام‌ها (نوع، وزن، سن، نژاد، قیمت)", status: "فعال" },
          { name: "ثبت و مدیریت فرآورده‌های دامی", status: "فعال" },
          { name: "مدیریت سفارشات دریافتی", status: "فعال" },
          { name: "دریافت و تسویه حساب مالی", status: "فعال" },
          { name: "مدیریت خودروهای حمل", status: "فعال" }
        ]
      },
      {
        category: "۳. پنل خریداران (Buyer Panel)",
        items: [
          { name: "جستجوی پیشرفته دام و فرآورده‌ها", status: "فعال" },
          { name: "مشاهده جزئیات و تصاویر", status: "فعال" },
          { name: "سبد خرید و ثبت سفارش", status: "فعال" },
          { name: "پرداخت آنلاین امن", status: "فعال" },
          { name: "پیگیری سفارشات و حمل", status: "فعال" }
        ]
      },
      {
        category: "۴. سیستم حمل و نقل",
        items: [
          { name: "ثبت درخواست حمل توسط خریدار", status: "فعال" },
          { name: "تخصیص خودرو توسط فروشنده", status: "فعال" },
          { name: "نمایش مسیر و رهگیری", status: "فعال" }
        ]
      }
    ],
    
    keyFeatures: [
      "ثبت و فروش دام و فرآورده‌ها",
      "پنل مجزا برای خریدار و فروشنده",
      "پرداخت آنلاین امن",
      "سیستم حمل و نقل تخصصی",
      "جستجوی پیشرفته",
      "امتیازدهی و نظرات"
    ],

    techStack: [
      { name: "React / Next.js", desc: "فرانت‌اند مدرن و سریع" },
      { name: "Tailwind CSS", desc: "طراحی اختصاصی و ریسپانسیو" },
      { name: "Node.js / Express", desc: "بک‌اند قدرتمند" },
      { name: "MySQL", desc: "دیتابیس ساختاریافته" },
      { name: "Stripe / پرداخت", desc: "درگاه پرداخت آنلاین" },
      { name: "Socket.io", desc: "ارتباط لحظه‌ای" }
    ]
  }

  // ================ فاز دوم ================
  const phase2Details = {
    title: "توسعه پیشرفته و هوشمندسازی",
    duration: "۳-۴ ماه",
    icon: <SparklesIcon className="w-6 h-6" />,
    
    modules: [
      {
        category: "۱. هوشمندسازی و تحلیل بازار",
        items: [
          { name: "داشبورد هوشمند قیمت‌های روز دام", status: "جدید" },
          { name: "تحلیل روند بازار و پیش‌بینی قیمت", status: "جدید" },
          { name: "سیستم پیشنهاد هوشمند به خریداران", status: "جدید" },
          { name: "گزارش‌گیری پیشرفته", status: "جدید" }
        ]
      },
      {
        category: "۲. توسعه ماژول حمل و نقل",
        items: [
          { name: "اتصال به سامانه‌های نقشه (Google Maps)", status: "جدید" },
          { name: "رهگیری لحظه‌ای خودروها", status: "جدید" },
          { name: "هشدارهای خودکار (تأخیر، مسیر)", status: "جدید" },
          { name: "امتیازدهی به رانندگان", status: "جدید" }
        ]
      },
      {
        category: "۳. اپلیکیشن موبایل",
        items: [
          { name: "اپلیکیشن فروشندگان (React Native)", status: "جدید" },
          { name: "اپلیکیشن خریداران (React Native)", status: "جدید" },
          { name: "ارسال اعلان‌های فوری", status: "جدید" }
        ]
      },
      {
        category: "۴. ابزارهای تخصصی",
        items: [
          { name: "ماشین حساب سودآوری دامداری", status: "جدید" },
          { name: "تقویم دام (زایش، واکسیناسیون)", status: "جدید" },
          { name: "سیستم مشاوره آنلاین", status: "جدید" }
        ]
      }
    ],
    
    keyFeatures: [
      "تحلیل هوشمند بازار دام",
      "اپلیکیشن موبایل فروشندگان و خریداران",
      "رهگیری لحظه‌ای حمل و نقل",
      "ابزارهای تخصصی دامداری",
      "سیستم پیشنهاد هوشمند",
      "اتصال به سامانه‌های نقشه"
    ]
  }

  // ================ سرویس‌های فاز دوم ================
  const phase2Services = [
    {
      name: "تحلیل هوشمند بازار",
      description: "نمودارهای قیمت، تحلیل روند و پیش‌بینی قیمت دام",
      icon: <ChartPieIcon className="w-8 h-8" />
    },
    {
      name: "اپلیکیشن موبایل",
      description: "دسترسی آسان خریداران و فروشندگان از طریق موبایل",
      icon: <DeviceTabletIcon className="w-8 h-8" />
    },
    {
      name: "رهگیری حمل و نقل",
      description: "مشاهده لحظه‌ای مسیر خودروی حمل دام",
      icon: <MapPinIcon className="w-8 h-8" />
    },
    {
      name: "ابزارهای تخصصی دام",
      description: "ماشین حساب سودآوری، تقویم دام و مشاوره",
      icon: <CalculatorIcon className="w-8 h-8" />
    },
    {
      name: "سیستم پیشنهاد هوشمند",
      description: "پیشنهاد دام و فرآورده بر اساس نیاز خریدار",
      icon: <SparklesIcon className="w-8 h-8" />
    },
    {
      name: "آموزش و دانشنامه",
      description: "مقالات و ویدئوهای آموزشی پرورش دام",
      icon: <AcademicCapIcon className="w-8 h-8" />
    }
  ]

  // ================ جدول مقایسه ================
  const comparisonTable = [
    { feature: "ثبت و فروش دام", phase1: "✅", phase2: "✅", desc: "ثبت کامل مشخصات" },
    { feature: "پنل فروشندگان", phase1: "✅", phase2: "✅", desc: "مدیریت کامل" },
    { feature: "پنل خریداران", phase1: "✅", phase2: "✅", desc: "جستجو و خرید" },
    { feature: "پرداخت آنلاین", phase1: "✅", phase2: "✅", desc: "پرداخت امن" },
    { feature: "حمل و نقل تخصصی", phase1: "✅ پایه", phase2: "✅ پیشرفته", desc: "رهگیری لحظه‌ای" },
    { feature: "تحلیل بازار", phase1: "❌", phase2: "✅", desc: "نمودار و پیش‌بینی" },
    { feature: "اپلیکیشن موبایل", phase1: "❌", phase2: "✅", desc: "دسترسی آسان" },
    { feature: "سیستم پیشنهاد هوشمند", phase1: "❌", phase2: "✅", desc: "پیشنهاد به خریدار" },
    { feature: "ابزارهای تخصصی", phase1: "❌", phase2: "✅", desc: "ماشین حساب و تقویم" },
    { feature: "امتیاز و نظرات", phase1: "✅", phase2: "✅", desc: "سیستم شفافیت" }
  ]
  const [isMenuOpen, setIsMenuOpen] = useState(false) // برای منوی موبایل


  const menuItems = [
    { name: 'خانه', href: '#' },
    { name: 'درباره ما', href: '#' },
    { name: 'خدمات', href: '#services' },
    { name: 'فازبندی', href: '#phases' },
    { name: 'تماس با ما', href: '#' }
  ]

 
  return (
    <main className="min-h-screen bg-gradient-to-b from-gray-50 to-white" dir="rtl">



<header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md shadow-sm border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            {/* لوگو */}
            <div className="flex-shrink-0 flex items-center gap-3">
              <img 
                src={logo} 
                alt="گوشت مهر گستران سیمرغ زیاران" 
                className="h-12 w-auto object-contain"
              />
              <div className="hidden sm:block">
                <p className="text-sm font-bold leading-tight" style={{ color: primaryColor }}>
                  گوشت مهر گستران
                </p>
                <p className="text-[10px] text-gray-500 leading-tight">
                  سیمرغ زیاران
                </p>
              </div>
            </div>

            {/* منوی دسکتاپ */}
            <nav className="hidden md:flex items-center gap-8">
              {menuItems.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="text-sm font-medium text-gray-700 hover:text-green-700 transition-colors duration-200 border-b-2 border-transparent hover:border-green-600 pb-1"
                >
                  {item.name}
                </a>
              ))}
              <button 
                className="px-5 py-2 rounded-full text-white text-sm font-bold transition-all duration-300 hover:shadow-lg transform hover:-translate-y-0.5"
                style={{ backgroundColor: primaryColor }}
              >
                دریافت پروپوزال
              </button>
            </nav>

            {/* دکمه منو موبایل */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
            >
              <svg className="w-6 h-6 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {isMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>

          {/* منوی موبایل */}
          {isMenuOpen && (
            <div className="md:hidden py-4 border-t border-gray-100">
              <div className="flex flex-col gap-3">
                {menuItems.map((item) => (
                  <a
                    key={item.name}
                    href={item.href}
                    className="text-sm font-medium text-gray-700 hover:text-green-700 transition-colors px-2 py-2 rounded-lg hover:bg-gray-50"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {item.name}
                  </a>
                ))}
                <button 
                  className="px-5 py-2 rounded-full text-white text-sm font-bold transition-all duration-300 hover:shadow-lg w-full"
                  style={{ backgroundColor: primaryColor }}
                >
                  دریافت پروپوزال
                </button>
              </div>
            </div>
          )}
        </div>
      </header>

      {/* ===== HERO SECTION با لوگو ===== */}
      <section className="relative pt-28 pb-20 overflow-hidden" style={{ backgroundColor: primaryColor }}>
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4">
          <div className="text-center text-white">
            
            {/* ===== لوگو در هیرو ===== */}
            <div className="flex justify-center mb-6">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 border border-white/20">
                <img 
                  src={logo} 
                  alt="گوشت مهر گستران سیمرغ زیاران" 
                  className="h-20 w-auto object-contain"
                />
              </div>
            </div>

            <div className="inline-flex items-center bg-white/20 backdrop-blur-sm rounded-full px-6 py-3 mb-6">
              <DocumentTextIcon className="w-6 h-6 ml-2" />
              <span className="font-bold">پروپوزال توسعه پلتفرم خرید و فروش دام</span>
            </div>
            
            <h1 className="text-4xl md:text-5xl font-black mb-6 leading-tight">
              گوشت مهر گستران سیمرغ زیاران
              <br />
              <span className="text-white/80">پلتفرم تخصصی خرید و فروش دام و فرآورده‌های دامی</span>
            </h1>
            
            <p className="text-xl text-white/80 max-w-3xl mx-auto mb-8">
              تحول دیجیتال در صنعت دامپروری با پلتفرمی هوشمند برای خریداران و فروشندگان
            </p>
            
            <div className="flex flex-wrap gap-6 justify-center">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 min-w-[160px]">
                <div className="text-2xl font-black text-white/90 mb-1">۲ فاز</div>
                <div className="text-white/70 text-sm">اجرای تدریجی</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 min-w-[160px]">
                <div className="text-2xl font-black text-white/90 mb-1">۸+</div>
                <div className="text-white/70 text-sm">سرویس تخصصی</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 min-w-[160px]">
                <div className="text-2xl font-black text-white/90 mb-1">۲</div>
                <div className="text-white/70 text-sm">نقش مجزا</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 min-w-[160px]">
                <div className="text-2xl font-black text-white/90 mb-1">آنلاین</div>
                <div className="text-white/70 text-sm">پرداخت + حمل</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* تحلیل وضعیت موجود */}
      <section id="executive" className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-10">
            <div className="inline-flex items-center rounded-full px-4 py-2 mb-4" style={{ backgroundColor: primaryColorLight }}>
              <span className="text-sm font-medium" style={{ color: primaryColor }}>تحلیل وضعیت موجود</span>
            </div>
            <h2 className="text-3xl font-black mb-3" style={{ color: primaryColor }}>از روش‌های سنتی تا پلتفرم هوشمند</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">صنعت دامپروری نیازمند تحول دیجیتال برای اتصال مستقیم خریداران و فروشندگان است</p>
          </div>

          <div className="grid md:grid-cols-2 gap-6 mb-8">
            <div className="rounded-2xl p-6 border-2" style={{ backgroundColor: primaryColorSuperLight, borderColor: primaryColorLight }}>
              <div className="flex items-center gap-2 mb-4">
                <CheckCircleIcon className="w-6 h-6" style={{ color: primaryColor }} />
                <h3 className="text-xl font-bold text-gray-800">فرصت‌های موجود</h3>
              </div>
              <ul className="space-y-2 text-sm text-gray-700">
                <li className="flex items-center gap-2">✓ سابقه و اعتبار شرکت در صنعت دام</li>
                <li className="flex items-center gap-2">✓ شبکه گسترده تأمین‌کنندگان</li>
                <li className="flex items-center gap-2">✓ دانش فنی و تخصصی در حوزه دامپروری</li>
                <li className="flex items-center gap-2">✓ ناوگان حمل و نقل اختصاصی</li>
              </ul>
            </div>

            <div className="rounded-2xl p-6 border-2" style={{ backgroundColor: '#fff5f5', borderColor: '#fecaca' }}>
              <div className="flex items-center gap-2 mb-4">
                <ShieldExclamationIcon className="w-6 h-6 text-red-500" />
                <h3 className="text-xl font-bold text-gray-800">چالش‌های کلیدی</h3>
              </div>
              <ul className="space-y-2 text-sm">
                <li className="flex items-center gap-2 text-red-700">⚠️ عدم پلتفرم آنلاین برای خرید و فروش</li>
                <li className="flex items-center gap-2 text-red-700">⚠️ عدم شفافیت در قیمت‌گذاری</li>
                <li className="flex items-center gap-2 text-red-700">⚠️ حمل و نقل سنتی بدون رهگیری</li>
                <li className="flex items-center gap-2 text-red-700">⚠️ عدم سیستم پرداخت آنلاین</li>
              </ul>
            </div>
          </div>

          <div className="overflow-x-auto rounded-xl border" style={{ borderColor: primaryColorLight }}>
            <table className="w-full text-sm">
              <thead className="border-b" style={{ backgroundColor: primaryColorSuperLight }}>
                <tr><th className="px-4 py-3 text-right">شاخص</th><th className="px-4 py-3 text-center">وضعیت فعلی</th><th className="px-4 py-3 text-center">وضعیت مطلوب</th></tr>
              </thead>
              <tbody>
                <tr className="border-b"><td className="px-4 py-2">خرید و فروش</td><td className="px-4 py-2 text-center text-red-600">سنتی</td><td className="px-4 py-2 text-center" style={{ color: primaryColor }}>آنلاین</td></tr>
                <tr className="border-b"><td className="px-4 py-2">پرداخت</td><td className="px-4 py-2 text-center text-red-600">نقدی</td><td className="px-4 py-2 text-center" style={{ color: primaryColor }}>آنلاین</td></tr>
                <tr className="border-b"><td className="px-4 py-2">حمل و نقل</td><td className="px-4 py-2 text-center text-red-600">بدون رهگیری</td><td className="px-4 py-2 text-center" style={{ color: primaryColor }}>رهگیری لحظه‌ای</td></tr>
                <tr><td className="px-4 py-2">شفافیت قیمت</td><td className="px-4 py-2 text-center text-red-600">پایین</td><td className="px-4 py-2 text-center" style={{ color: primaryColor }}>بالا</td></tr>
              </tbody>
            </table>
          </div>

          <div className="mt-6 p-5 text-center rounded-xl" style={{ backgroundColor: primaryColorSuperLight }}>
            <p className="text-sm text-gray-700">
              <span className="font-bold" style={{ color: primaryColor }}>هدف:</span> ایجاد پلتفرمی هوشمند برای اتصال خریداران و فروشندگان با پرداخت آنلاین و حمل تخصصی
            </p>
          </div>
        </div>
      </section>

      {/* چشم‌انداز و اهداف */}
      <section id="vision" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-black mb-4" style={{ color: primaryColor }}>چشم‌انداز و اهداف پروژه</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">تبدیل گوشت مهر گستران به پیشگام دیجیتال در صنعت خرید و فروش دام و فرآورده‌های دامی</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <div className="rounded-2xl p-6 border" style={{ backgroundColor: primaryColorSuperLight, borderColor: primaryColorLight }}>
              <div className="w-14 h-14 rounded-xl flex items-center justify-center mb-4" style={{ backgroundColor: primaryColorLight }}>
                <ShoppingBagIcon className="w-7 h-7" style={{ color: primaryColor }} />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">بازارگاه تخصصی دام</h3>
              <p className="text-gray-600 text-sm">پلتفرمی کامل برای خرید و فروش انواع دام و فرآورده‌های دامی با دسته‌بندی حرفه‌ای</p>
            </div>
            
            <div className="rounded-2xl p-6 border" style={{ backgroundColor: primaryColorSuperLight, borderColor: primaryColorLight }}>
              <div className="w-14 h-14 rounded-xl flex items-center justify-center mb-4" style={{ backgroundColor: primaryColorLight }}>
                <CreditCardIcon className="w-7 h-7" style={{ color: primaryColor }} />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">پرداخت آنلاین امن</h3>
              <p className="text-gray-600 text-sm">پرداخت آسان و امن از طریق درگاه‌های معتبر بانکی با تسویه خودکار فروشندگان</p>
            </div>
            
            <div className="rounded-2xl p-6 border" style={{ backgroundColor: primaryColorSuperLight, borderColor: primaryColorLight }}>
              <div className="w-14 h-14 rounded-xl flex items-center justify-center mb-4" style={{ backgroundColor: primaryColorLight }}>
                <TruckIcon className="w-7 h-7" style={{ color: primaryColor }} />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">حمل و نقل تخصصی</h3>
              <p className="text-gray-600 text-sm">سیستم حمل و نقل با خودروهای مخصوص حمل دام و رهگیری لحظه‌ای مسیر</p>
            </div>
          </div>

          {/* معماری کلی */}
          <div className="rounded-2xl p-8 border" style={{ backgroundColor: primaryColorSuperLight, borderColor: primaryColorLight }}>
            <div className="flex items-center gap-3 mb-6">
              <ServerIcon className="w-7 h-7" style={{ color: primaryColor }} />
              <h3 className="text-xl font-bold text-gray-800">معماری کلی پلتفرم</h3>
            </div>
            <div className="grid md:grid-cols-4 gap-6">
              <div className="text-center">
                <div className="w-16 h-16 mx-auto bg-white rounded-2xl shadow-lg flex items-center justify-center mb-3 border-2" style={{ borderColor: primaryColorLight }}>
                  <UsersIcon className="w-8 h-8" style={{ color: primaryColor }} />
                </div>
                <p className="font-bold text-gray-800">مدیریت کاربران</p>
                <p className="text-xs text-gray-500 mt-1">خریدار / فروشنده</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 mx-auto bg-white rounded-2xl shadow-lg flex items-center justify-center mb-3 border-2" style={{ borderColor: primaryColorLight }}>
                  <CubeIcon className="w-8 h-8" style={{ color: primaryColor }} />
                </div>
                <p className="font-bold text-gray-800">مدیریت دام</p>
                <p className="text-xs text-gray-500 mt-1">ثبت و فروش</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 mx-auto bg-white rounded-2xl shadow-lg flex items-center justify-center mb-3 border-2" style={{ borderColor: primaryColorLight }}>
                  <CreditCardIcon className="w-8 h-8" style={{ color: primaryColor }} />
                </div>
                <p className="font-bold text-gray-800">پرداخت</p>
                <p className="text-xs text-gray-500 mt-1">آنلاین + تسویه</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 mx-auto bg-white rounded-2xl shadow-lg flex items-center justify-center mb-3 border-2" style={{ borderColor: primaryColorLight }}>
                  <TruckIcon className="w-8 h-8" style={{ color: primaryColor }} />
                </div>
                <p className="font-bold text-gray-800">حمل و نقل</p>
                <p className="text-xs text-gray-500 mt-1">رهگیری لحظه‌ای</p>
              </div>
            </div>
            <div className="mt-6 pt-6 border-t text-center" style={{ borderColor: primaryColorLight }}>
              <p className="text-sm text-gray-600">
                <span className="font-bold" style={{ color: primaryColor }}>↓</span> معماری منعطف برای توسعه در فاز دوم 
                <span className="font-bold" style={{ color: primaryColor }}> ↓</span>
              </p>
              <div className="flex justify-center gap-4 mt-3 flex-wrap">
                {["تحلیل بازار", "اپلیکیشن موبایل", "ابزارهای تخصصی", "سیستم پیشنهاد هوشمند"].map(item => (
                  <span key={item} className="px-3 py-1 rounded-full text-xs" style={{ backgroundColor: primaryColorLight, color: primaryColorDark }}>{item}</span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* خدمات اصلی */}
      <section id="services" className="py-20" style={{ backgroundColor: primaryColorLight }}>
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <div className="inline-flex items-center rounded-full px-4 py-2 mb-4" style={{ backgroundColor: primaryColorSuperLight }}>
              <span className="text-sm font-bold" style={{ color: primaryColor }}>سرویس‌های اصلی</span>
            </div>
            <h2 className="text-3xl font-black mb-4" style={{ color: primaryColor }}>خدمات پلتفرم خرید و فروش دام</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">۸ سرویس تخصصی برای اتصال خریداران و فروشندگان دام و فرآورده‌های دامی</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
            {mainServices.map((service, index) => (
              <div key={index} className="bg-white rounded-xl p-5 border transition-all duration-300 hover:shadow-lg group" style={{ borderColor: primaryColorLight }}>
                <div className="flex items-start gap-3 mb-3">
                  <div className="w-11 h-11 rounded-lg flex items-center justify-center flex-shrink-0" style={{ backgroundColor: primaryColorLight, color: primaryColor }}>{service.icon}</div>
                  <div>
                    <h3 className="font-bold text-gray-800 text-sm group-hover" style={{ color: primaryColor }}>{service.name}</h3>
                    <span className="inline-block px-2 py-0.5 bg-gray-100 text-gray-600 text-[10px] rounded-full mt-1">{service.formType}</span>
                  </div>
                </div>
                <p className="text-gray-600 text-xs mb-3">{service.description}</p>
                <div className="space-y-1.5">
                  {service.features.slice(0, 2).map((f, i) => (
                    <div key={i} className="flex items-center text-xs text-gray-600">
                      <CheckCircleIcon className="w-3 h-3 ml-1.5 flex-shrink-0" style={{ color: primaryColor }} />
                      <span>{f}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* فازبندی */}
      <section id="phases" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-black mb-4" style={{ color: primaryColor }}>فازبندی اجرای پروژه</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">رویکرد تدریجی برای کاهش ریسک و بهره‌برداری زودهنگام</p>
          </div>

          <div className="grid lg:grid-cols-2 gap-8">
            {/* فاز اول */}
            <div className="rounded-2xl border-2 overflow-hidden" style={{ borderColor: primaryColorLight }}>
              <div className="px-6 py-4" style={{ backgroundColor: primaryColor }}>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center">
                      <span className="text-white font-black text-xl">۱</span>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-white">فاز اول</h3>
                      <p className="text-white/70 text-sm">{phase1Details.duration}</p>
                    </div>
                  </div>
                  <div className="px-4 py-2 bg-white/20 rounded-full">
                    <span className="text-white text-sm font-bold">شروع پلتفرم</span>
                  </div>
                </div>
              </div>
              <div className="p-6 space-y-6">
                {phase1Details.modules.map((module, idx) => (
                  <div key={idx}>
                    <h4 className="font-bold text-gray-800 mb-3 flex items-center gap-2">
                      <div className="w-2 h-2 rounded-full" style={{ backgroundColor: primaryColor }}></div>
                      {module.category}
                    </h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2 pr-4">
                      {module.items.map((item, i) => (
                        <div key={i} className="flex items-center gap-2 text-sm text-gray-700">
                          <CheckCircleIcon className="w-3.5 h-3.5 flex-shrink-0" style={{ color: primaryColor }} />
                          <span>{item.name}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
                <div className="mt-4 pt-4 border-t flex flex-wrap gap-2" style={{ borderColor: primaryColorLight }}>
                  {phase1Details.keyFeatures.map((f, i) => (
                    <span key={i} className="px-3 py-1.5 text-xs rounded-full" style={{ backgroundColor: primaryColorLight, color: primaryColor }}>{f}</span>
                  ))}
                </div>
              </div>
            </div>

            {/* فاز دوم */}
            <div className="rounded-2xl border-2 overflow-hidden" style={{ borderColor: primaryColorLight }}>
              <div className="px-6 py-4" style={{ backgroundColor: primaryColorDark }}>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center">
                      <span className="text-white font-black text-xl">۲</span>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-white">فاز دوم</h3>
                      <p className="text-white/70 text-sm">{phase2Details.duration}</p>
                    </div>
                  </div>
                  <div className="px-4 py-2 bg-white/20 rounded-full">
                    <span className="text-white text-sm font-bold">توسعه هوشمند</span>
                  </div>
                </div>
              </div>
              <div className="p-6 space-y-6">
                {phase2Details.modules.map((module, idx) => (
                  <div key={idx}>
                    <h4 className="font-bold text-gray-800 mb-3 flex items-center gap-2">
                      <div className="w-2 h-2 rounded-full" style={{ backgroundColor: primaryColor }}></div>
                      {module.category}
                    </h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2 pr-4">
                      {module.items.map((item, i) => (
                        <div key={i} className="flex items-center gap-2 text-sm text-gray-700">
                          <SparklesIcon className="w-3.5 h-3.5 flex-shrink-0" style={{ color: primaryColor }} />
                          <span>{item.name}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
                <div className="mt-4 pt-4 border-t flex flex-wrap gap-2" style={{ borderColor: primaryColorLight }}>
                  {phase2Details.keyFeatures.map((f, i) => (
                    <span key={i} className="px-3 py-1.5 text-xs rounded-full" style={{ backgroundColor: primaryColorLight, color: primaryColor }}>{f}</span>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* سرویس‌های فاز دوم */}
          <div className="mt-12">
            <div className="text-center mb-8">
              <h3 className="text-2xl font-bold text-gray-800">سرویس‌های جدید در فاز دوم</h3>
              <p className="text-gray-600 mt-2">امکانات پیشرفته برای هوشمندسازی پلتفرم</p>
            </div>
            <div className="grid md:grid-cols-3 gap-5">
              {phase2Services.map((service, index) => (
                <div key={index} className="rounded-xl p-4 border transition-all" style={{ backgroundColor: primaryColorSuperLight, borderColor: primaryColorLight }}>
                  <div className="flex items-center gap-3 mb-2">
                    <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ backgroundColor: primaryColorLight, color: primaryColor }}>{service.icon}</div>
                    <h4 className="font-bold text-gray-800">{service.name}</h4>
                  </div>
                  <p className="text-gray-600 text-sm">{service.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* مزایا */}
      <section id="benefits" className="py-20" style={{ backgroundColor: primaryColorLight }}>
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-black mb-4" style={{ color: primaryColor }}>مزایای کلیدی پروژه</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">چرا این پلتفرم بهترین انتخاب برای تحول دیجیتال صنعت دام است؟</p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {keyBenefits.map((benefit, index) => (
              <div key={index} className="bg-white rounded-xl p-6 border transition-all group" style={{ borderColor: primaryColorLight }}>
                <div className="w-14 h-14 rounded-xl flex items-center justify-center mb-4" style={{ backgroundColor: primaryColorLight, color: primaryColor }}>{benefit.icon}</div>
                <h3 className="text-lg font-bold text-gray-800 mb-2 transition-colors group-hover" style={{ color: primaryColor }}>{benefit.title}</h3>
                <p className="text-gray-600 text-sm">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* جدول مقایسه */}
      <section id="comparison" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-black mb-4" style={{ color: primaryColor }}>مقایسه قابلیت‌ها در دو فاز</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">نمای کلی از آنچه در هر فاز ارائه می‌شود</p>
          </div>
          <div className="overflow-x-auto rounded-2xl border" style={{ backgroundColor: primaryColorSuperLight, borderColor: primaryColorLight }}>
            <table className="w-full">
              <thead className="border-b" style={{ borderColor: primaryColorLight }}>
                <tr>
                  <th className="text-right px-6 py-4 text-sm font-bold text-gray-800">قابلیت</th>
                  <th className="text-center px-6 py-4 text-sm font-bold" style={{ color: primaryColor }}>فاز اول</th>
                  <th className="text-center px-6 py-4 text-sm font-bold" style={{ color: primaryColor }}>فاز دوم</th>
                  <th className="text-right px-6 py-4 text-sm font-bold text-gray-800">توضیحات</th>
                </tr>
              </thead>
              <tbody className="divide-y" style={{ borderColor: primaryColorLight }}>
                {comparisonTable.map((item, index) => (
                  <tr key={index}>
                    <td className="px-6 py-3 text-sm font-medium text-gray-800">{item.feature}</td>
                    <td className="text-center px-6 py-3"><span className="font-bold" style={{ color: primaryColor }}>{item.phase1}</span></td>
                    <td className="text-center px-6 py-3"><span className="font-bold" style={{ color: primaryColor }}>{item.phase2}</span></td>
                    <td className="px-6 py-3 text-xs text-gray-600">{item.desc}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="mt-8 p-5 rounded-xl text-center" style={{ backgroundColor: primaryColorSuperLight }}>
            <p className="text-gray-700 text-sm">
              <span className="font-bold" style={{ color: primaryColor }}>فاز اول</span> زیرساخت اصلی و خدمات ضروری را پوشش می‌دهد و 
              <span className="font-bold" style={{ color: primaryColor }}> فاز دوم</span> پلتفرم را با هوشمندسازی و ابزارهای پیشرفته تکمیل می‌کند.
            </p>
          </div>
        </div>
      </section>

      {/* تکنولوژی */}
      <section className="py-20" style={{ backgroundColor: primaryColorLight }}>
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-black mb-4" style={{ color: primaryColor }}>تکنولوژی‌های مورد استفاده</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">استفاده از مدرن‌ترین ابزارها برای تضمین کیفیت، امنیت و سرعت</p>
          </div>
          <div className="grid md:grid-cols-3 gap-4">
            {phase1Details.techStack.map((tech, index) => (
              <div key={index} className="bg-white rounded-xl p-4 text-center border transition-all" style={{ borderColor: primaryColorLight }}>
                <div className="w-12 h-12 mx-auto rounded-lg flex items-center justify-center mb-3" style={{ backgroundColor: primaryColorLight }}>
                  <CpuChipIcon className="w-6 h-6" style={{ color: primaryColor }} />
                </div>
                <p className="font-bold text-gray-800 text-sm">{tech.name}</p>
                <p className="text-gray-500 text-[10px] mt-1">{tech.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 relative overflow-hidden" style={{ backgroundColor: primaryColor }}>
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        </div>
        <div className="relative max-w-4xl mx-auto px-4 text-center">
          <div className="inline-flex items-center bg-white/20 backdrop-blur-sm rounded-full px-6 py-3 mb-8">
            <RocketLaunchIcon className="w-6 h-6 ml-2 text-white" />
            <span className="font-bold text-white">آماده برای شروع تحول دیجیتال در صنعت دام</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-white mb-6">
            پلتفرمی که صنعت دامپروری را<br />
            <span className="text-white/80">متحول می‌کند</span>
          </h2>
          <p className="text-xl text-white/80 leading-relaxed mb-10">
            از خرید و فروش سنتی تا پلتفرمی هوشمند با پرداخت آنلاین و حمل تخصصی
          </p>
          <div className="mt-10 pt-8 border-t border-white/20 flex flex-wrap justify-center gap-6 text-white/60 text-sm">
            <span className="flex items-center gap-2"><ShoppingBagIcon className="w-4 h-4" />خرید و فروش آنلاین</span>
            <span className="flex items-center gap-2"><CreditCardIcon className="w-4 h-4" />پرداخت امن</span>
            <span className="flex items-center gap-2"><TruckIcon className="w-4 h-4" />حمل تخصصی</span>
            <span className="flex items-center gap-2"><UsersIcon className="w-4 h-4" />دو نقش مجزا</span>
          </div>
        </div>
      </section>
    </main>
  )
}

export default Proposal